import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class AgbService {

  public constructor(private readonly _httpClient: HttpClient) {}

  public loadAgbText(): Promise<string> {
    return this._httpClient.get<string>("api/agb").toPromise();
  }

}
